const e=".gator-truncate{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}";export{e as default};
